export default {
  dpp: '云桌面测试管理平台',
  sk: {
    route: {
      projectMng: '项目',
      pocMng: '我的项目',
      reportMng: '兼容性案例上报',
      reportQryMng: '兼容性案例查询',
      poc: '售前测试',
      helpPoc: '售前帮助指导',
      helpDelivery: '交付帮助指导',
      guide: '首页',
      deliveryDeploy: '交付部署',
      deliveryDeployConfig: '交付部署配置',
      deliveryDeployMng: '交付中项目',
      toBeDeliveryMng: '待交付项目',
      projectSetting: '项目配置',
      systemSetting: '系统配置',
      sceneMng: '场景配置',
      industryMng: '行业配置',
      featureMng: '功能配置',
      featureValueMng: '功能价值配置',
      caseMng: '用例配置',
      compatibleMng: '兼容性管理',
      peripheralMng: '外设配置',
      softwareMng: '软件配置',
      compatibleSoftwareMng: '软件兼容性',
      compatiblePeripheralMng: '外设兼容性',
      softwareBlackListMng: '软件黑名单配置',
      caseSoftwareMng: '软件用例',
      casePeripheralMng: '外设用例',
      caseBusiMng: '功能用例',
      caseRepo: '用例库',
      featureLimit: '功能限制说明',
      serverCalculator: '资源配置管理',
      tool: '工具下载',
      cloudDeskTopOtherSystem: '云桌面其他系统',
      onlineTool: '在线工具',
      toolMng: '工具配置',
      osTypeMng: '操作系统配置',
      serverMng: '服务器配置',
      terminalMng: '终端配置',
      productMng: '产品版本配置',
      batchMaintenance: '配置批量运维',
      productStrategyMng: '产品选择策略配置',
      positionMng: '岗位配置',
      systemSettingMng: '维护开关',
      npsMng: 'NPS配置',
      sharedMng: '共享信息管理',
      userMng: '用户管理',
      maintenanceMng: '运维管理',
      copyScene: '复制场景功能用例',
      channelMng: '渠道用户',
      userInfo: '用户信息',
      serverCalSetting: '资源计算器配置',
      gpuCardMng: '显卡配置',
      calSoftwareMng: '杀毒加密软件',
      desktopElementMng: '云桌面元素配置',
      deliveryGuideMng: '指导配置',
      segmentSceneMng: '细分场景配置',
      copyFeatureAndTestCaseMng: '复制版本功能用例',
      areaIndustryUserMng: '区域&部门人员配置',
      feedbackCollectMng: '问题或建议反馈',
      feedbackMng: '问题与建议管理',
      productConfig: '产品配置',
      manufacturerService: '选型报价工具',
      vdiProductSelector: 'VDI产品与服务选型报价',
      servicePriceAudit: '选型报价工具审计'
    },
    navbar: {
      more: '',
      switchRole: '切换角色'
    }
  }
}
